import { render, staticRenderFns } from "./addMaterials.vue?vue&type=template&id=6b0898e3&scoped=true"
import script from "./addMaterials.vue?vue&type=script&lang=js"
export * from "./addMaterials.vue?vue&type=script&lang=js"
import style0 from "./addMaterials.vue?vue&type=style&index=0&id=6b0898e3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0898e3",
  null
  
)

export default component.exports